import React, { useCallback, useState } from 'react';

import { Drawer, IconButton, SvgIcon } from '@mui/material';

import MenuList from 'pages/layout/components/MenuList';
import UpgradeLicenseButton from 'pages/layout/components/UpgradeLicenseButton';

import IconClose from './assets/close.svg';
import IconMenu from './assets/menu.svg';
import useStyles from './styles';

interface Props {
    container?: () => HTMLElement;
    className?: string;
}

const DrawerMenuButton: React.FC<Props> = ({ className, container }) => {
    const { classes, cx } = useStyles();

    const [isOpen, setIsOpen] = useState(false);

    const toggle = useCallback(() => setIsOpen((state) => !state), []);
    const close = useCallback(() => setIsOpen(false), []);

    return (
        <>
            <IconButton onClick={toggle} disableFocusRipple centerRipple className={cx(classes.button, className)}>
                <SvgIcon>{isOpen ? <IconClose /> : <IconMenu />}</SvgIcon>
            </IconButton>
            <Drawer
                anchor="left"
                open={isOpen}
                onClose={close}
                container={container}
                classes={{ paper: classes.paper, modal: classes.modal }}
            >
                <MenuList
                    onMenuItemClick={close}
                    additional={<UpgradeLicenseButton className={classes.upgrade} />}
                    className={classes.menu}
                />
            </Drawer>
        </>
    );
};

export default DrawerMenuButton;
